import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export default function PinterestIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const width = t1 === undefined ? 28 : t1;
  const height = t2 === undefined ? 28 : t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M14.03 28h-.06C6.266 28 0 21.733 0 14.03v-.06C0 6.266 6.267 0 13.97 0h.06C21.734 0 28 6.267 28 13.97v.06C28 21.734 21.733 28 14.03 28zM13.97.948C6.788.948.947 6.788.947 13.969v.062c0 7.18 5.84 13.021 13.021 13.021h.062c7.18 0 13.021-5.84 13.021-13.021v-.062c0-7.18-5.84-13.021-13.021-13.021h-.062z" fill="#000" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M12.765 17.699l-.043.15c-.716 2.804-.795 3.427-1.53 4.729-.351.619-.747 1.205-1.184 1.766-.049.064-.095.145-.194.125-.108-.022-.116-.12-.128-.206a15.1 15.1 0 01-.154-2.567c.037-1.12.175-1.505 1.62-7.578a.428.428 0 00-.034-.253c-.346-.933-.414-1.88-.111-2.839.653-2.071 3.002-2.23 3.412-.52.253 1.056-.416 2.44-.93 4.485-.425 1.687 1.562 2.887 3.259 1.655 1.566-1.136 2.173-3.858 2.058-5.787-.228-3.847-4.446-4.679-7.122-3.44-3.068 1.419-3.765 5.221-2.38 6.96.176.22.506.356.449.58-.09.348-.168.698-.265 1.044-.072.258-.482.352-.743.246a3.138 3.138 0 01-1.281-.96c-1.177-1.457-1.513-4.338.042-6.778 1.723-2.702 4.929-3.796 7.855-3.464 3.496.397 5.705 2.785 6.118 5.495.189 1.234.053 4.277-1.68 6.429-1.992 2.472-5.223 2.636-6.714 1.118-.115-.116-.207-.252-.32-.391z" fill="#000" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== height || $[7] !== props || $[8] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t3}{t4}</svg>;
    $[6] = height;
    $[7] = props;
    $[8] = width;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}